export const MenuItems = [
  {
    title: " ABOUT",
    url: "/about",
    cName: "nav-links",
    icon: "+",
    bool: "false"
  },
  {
    title: "SERVICES",
    url: "/services",
    cName: "nav-links",
    icon: "+",
    bool: "false"
  },
  {
    title: "SOLUTIONS",
    url: "/solutions",
    cName: "nav-links",
    icon: "+",
    bool: "false"
  },
  {
    title: "CAREERS",
    url: "/careers",
    cName: "nav-links",
    icon: "+",
    bool: "false"
  },
  {
    title: "CONTACT",
    url: "/contacts",
    cName: "nav-links",
    icon: "+",
    bool: "false"
  },
  {
    title: "WORKS",
    url: "https://work.firsteventech.com/",
    cName: "nav-links",
    icon: "+",
    bool: "false"
  }
];
